window.youtube_media = null;

window.getNextSiblingByClass = function (node, css_class) {
    let sibling = node.nextSibling;
    while (sibling) {
        if (sibling.classList && sibling.classList.contains(css_class)) break;
        sibling = sibling.nextSibling;
    }
    return sibling;
}

window.getElementRealHeight = function (node) {
    let height = 0;
    let oStyle = window.getComputedStyle(node);
    height = node.clientHeight + (parseInt(oStyle.borderTopWidth) || 0) + (parseInt(oStyle.borderBottomWidth) || 0);
    return height;
}

window.on_window_resize = function () {
    document.querySelectorAll('.refresh-height-on-resize').forEach((item) => {
        let item_height = window.getElementRealHeight(item);
        if (item_height > 0) {
            let sub_element = item.querySelector('.refresh-height-on-resize--clild');
            if (sub_element) {
                let sub_element_height = window.getElementRealHeight(sub_element);
                item.style.height = sub_element_height + 'px';
            }
        }
    });
}

window.addEventListener('resize', debounce(() => { window.on_window_resize(); }, 500));

class ProductTemplate extends HTMLElement {
    constructor() {
        super();

        this.product_media_len = parseInt(this.dataset.mediaSize);
        this.is_quick_shop = this.classList.contains('is-quick-shop');
        this.variant_selects = this.querySelector('variant-radios');

        this.product_select_tpl = this.querySelector('.ProductSelect-product-template');
        this.quantity_product = this.querySelector('.Quantity-product');

        this.slider_container_medias = this.querySelector('.irq-product-media-main');
        this.container_medias_scroller = this.slider_container_medias.querySelector('.snap-product-medias');

        this.slider_container_thumbnails = this.querySelector('.slider-container-thumbnails');
        this.container_thumbnails_scroller = this.slider_container_thumbnails.querySelector('.snap-product-thumbnails');
        this.container_thumbnails_list_btn_next = this.slider_container_thumbnails.querySelector('.next');
        this.container_thumbnails_list_btn_prev = this.slider_container_thumbnails.querySelector('.previous');

        this.small_imgs = this.querySelectorAll('.product-single__thumbnail');
        this.desktop_snap_imgs = this.querySelectorAll('.slider-container-thumbnails .snap-product-img-desktop');

        this.setupOnMediaScroll();
        this.setupEventListeners();
    }

    setupOnMediaScroll() {
        this.container_medias_scroller.addEventListener('scroll', debounce(() => {
            let index = Math.round(this.container_medias_scroller.scrollLeft / this.container_medias_scroller.scrollWidth * this.product_media_len);
            this.querySelectorAll('.flickity-page-dots .dot.is-selected').forEach((element) => { element.classList.remove('is-selected'); });
            this.querySelectorAll('.flickity-page-dots .dot')[index].classList.add('is-selected');
        }, 100));
    }

    sliderContainerMediasToPage(page) {
        this.container_medias_scroller.scrollTo({left: this.container_medias_scroller.clientWidth * (page - 1), behavior: 'smooth'});
    }

    setupEventListeners() {
        if (this.variant_selects) this.setupVariantChange();
        if (this.small_imgs.length > 1) this.setupThumbnailClick();
        if (this.desktop_snap_imgs.length > 5) this.setupDesktopSnap();
        this.setupPlayClick();
        this.setupQuantityChange();
        this.setupBuyNow();
        this.setupAddToCart();
        this.setupTabToggle();
    }

    setupTabToggle() {
        this.querySelectorAll('.product-info--tab-title').forEach((element) => {
            element.addEventListener('click', function () {
                let dst_element = window.getNextSiblingByClass(element, 'refresh-height-on-resize');
                if (dst_element) {
                    let dst_element_height = window.getElementRealHeight(dst_element);
                    if (dst_element_height > 0) {
                        element.classList.remove('active');
                        dst_element.style.height = '0px';
                    } else {
                        let new_height = 0;
                        let dst_sub_element = dst_element.querySelector('.refresh-height-on-resize--clild');
                        if (dst_sub_element) new_height = window.getElementRealHeight(dst_sub_element);
                        element.classList.add('active');
                        dst_element.style.height = new_height + 'px';
                    }
                }
                element.classList.toggle('active');
            });
        });
    }

    setupAddToCart() {
        const self = this;

        this.querySelector('.submit-add-in-stock').addEventListener('click', function (event) {
            event.preventDefault();
            let cartAddFormData = new FormData();
            cartAddFormData.append('form_type','product');
            cartAddFormData.append('utf8', '✓');
            cartAddFormData.append('quantity', self.quantity_product.value);
            cartAddFormData.append('id', self.product_select_tpl.value);

            fetch("/cart/add.js", {
                method: "POST",
                credentials: "include",
                body: cartAddFormData,
                headers: new Headers({'X-Requested-With': 'XMLHttpRequest'})
            }).then((res)=>res.json()).then((response)=>{
                if (response.status == '422') {
                    self.querySelector('.cart-add-error').innerHTML = response.description;
                    self.querySelector('.cart-add-error').classList.remove('hide');
                    throw response.description;
                } else {
                    self.querySelector('.cart-add-error').innerHTML = '';
                    self.querySelector('.cart-add-error').classList.add('hide');
                }
                let time_now = new Date().getTime();
                return fetch("/cart?t=" + time_now + "&view=ajax", {
                    method: "GET",
                    credentials: "include"
                })
            }).then(response => response.text()).then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let right_cart__items = doc.querySelector('.right_cart__items');
                let data_cart_subtotal = right_cart__items.dataset.cartSubtotal;
                let right_cart_data_count = right_cart__items.dataset.count;
                let right_cart_subtotal = document.querySelector('.right_cart_footer_subtotal [data-subtotal]');
                let right_cart_products = document.querySelector('.right_cart_products');
                let header__cart_count = document.querySelector('#header__cart-count');
                right_cart_products.innerHTML = '';
                right_cart_products.append(right_cart__items);
                right_cart_subtotal.innerHTML = data_cart_subtotal;
                if (right_cart_data_count > 99) {
                    header__cart_count.innerHTML = '99';
                } else if (right_cart_data_count > 0) {
                    header__cart_count.innerHTML = '' + right_cart_data_count;
                } else {
                    right_cart_data_count.innerHTML = ''
                }
                if (right_cart_data_count == 0) {
                    document.querySelector('.right_cart_content').classList.add('hide');
                    document.querySelector('.right_cart_empty').classList.remove('hide');
                } else {
                    document.querySelector('.right_cart_empty').classList.add('hide');
                    document.querySelector('.right_cart_content').classList.remove('hide');
                }
                if (self.is_quick_shop) window.quick_shop.hide();
                window.right_cart_init();
                window.show_right_cart();
            }).catch((err) => console.log(err));
        });
    }

    setupVariantChange() {
        this.variant_selects.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia();

        if (!this.currentVariant) {
            this.setUnavailable();
        } else {
            if (!this.is_quick_shop) this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.variant_selects.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    updateOptions1() {
        this.options = Array.from(this.variant_selects.querySelectorAll('select'), (select) => select.value);
        //console.log(this.options);//["30lbs"]
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
        //console.log(this.currentVariant);
    }

    updateMedia() {
        if (this.currentVariant.featured_media) {
            this.querySelectorAll('.product-single__thumbnail').forEach((small_img) => {
                if (small_img.dataset.thumbnailId == 'thumbnail_' + this.currentVariant.featured_media.id) {
                    small_img.click();
                }
            });
        }
    }

    setUnavailable() {
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({ }, '', `${this.variant_selects.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForm = this.querySelector('form.product-form');
        const product_sel = productForm.querySelector('select[name="id"]');
        product_sel.value = this.currentVariant.id;
    }

    renderProductInfo() {
        const self = this;
        console.log(this.variant_selects.dataset)
        fetch(`${this.variant_selects.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.variant_selects.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const price_class = `.price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = self.querySelector(price_class);
                const source = html.querySelector(price_class);
                const sel_variant_id = html.querySelector('.ProductSelect-product-template').value;

                for (let i = 0; i < self.querySelector('.ProductSelect-product-template').options.length; i++) {
                    if (self.querySelector('.ProductSelect-product-template').options[i].value == sel_variant_id) {
                        self.querySelector('.ProductSelect-product-template').options[i].selected = true;
                        break;
                    }
                }

                if (source && destination) destination.innerHTML = source.innerHTML;

                let sku_source = html.querySelector('.variant-sku');
                let sku_destination = this.querySelector('.variant-sku');
                if (sku_source && sku_destination) {
                    sku_destination.innerHTML = sku_source.innerHTML;
                }

                const price = self.querySelector(`.price-${this.dataset.section}`);
                if (price) price.classList.remove('visibility-hidden');

                if (html.querySelector('.product-form.product-form--variant-sold-out')) {
                    self.querySelector('.submit-add-out-stock').classList.remove('pre-hide');
                    self.querySelector('.submit-add-in-stock').classList.add('pre-hide');
                    self.querySelector('.buy-it-now-btn').classList.add('pre-hide');
                    self.querySelector('.product-content--inventory-status').classList.add('product-sold-out');
                } else {
                    self.querySelector('.submit-add-out-stock').classList.add('pre-hide');
                    self.querySelector('.submit-add-in-stock').classList.remove('pre-hide');
                    self.querySelector('.buy-it-now-btn').classList.remove('pre-hide');
                    self.querySelector('.product-content--inventory-status').classList.remove('product-sold-out');
                }
            });
    }


    setupQuantityChange() {
        this.querySelector('.Decrease').addEventListener('click', () => {
            let v = this.quantity_product.value;
            v = v <= 1 ? 1 : --v;
            this.quantity_product.value = v;
        });
        this.querySelector('.Increase').addEventListener('click', () => {
            let v = this.quantity_product.value;
            v = v >= 9999 ? 9999 : ++v;
            this.quantity_product.value = v;
        });
    }

    setupBuyNow() {
        const self = this;
        this.querySelector('.buy-it-now-btn').addEventListener('click', function () {
            fetch("/payments/config?currency=" + Shopify.currency.active, {
                method: "GET",
                credentials: "include",
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            }).then((res)=>res.json()).then((response)=>{
                if (response.paymentInstruments && response.paymentInstruments.accessToken) {
                    let accessTokenEncode = encodeURI(response.paymentInstruments.accessToken);
                    let accessTokenBase64 = btoa(accessTokenEncode);
                    let product_id = self.product_select_tpl.value;
                    let product_qty = self.quantity_product.value;
                    let opt = {
                        "checkout": {
                            "line_items": [{"variant_id": product_id, "quantity": product_qty}],
                            "secret": true,
                            "wallet_name": "Checkout",
                            "is_upstream_button": true,
                            "page_type": "product",
                            "presentment_currency": Shopify.currency.active
                        }
                    };
                    return fetch("/wallets/checkouts.json", {
                        method: "POST",
                        credentials: "include",
                        body: JSON.stringify(opt),
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic ' + accessTokenBase64
                        })
                    });
                } else {
                    throw new Error("accessToken error!");
                }
            }).then((res)=>res.json()).then((response)=>{
                if (response.checkout && response.checkout.web_url) {
                    window.location.href = response.checkout.web_url;
                } else {
                    throw new Error("checkout error!");
                }
            }).catch((err) => {
                console.error(err);
            });
        });
    }

    setupPlayClick() {
        this.querySelectorAll('.model-media__play').forEach((play_btn) => {
            play_btn.addEventListener('click', function (event) {
                const deferred_media = play_btn.parentNode.parentNode.querySelector('deferred-media');
                const content = document.createElement('div');
                content.appendChild(deferred_media.querySelector('template').content.firstElementChild.cloneNode(true));
                deferred_media.setAttribute('loaded', true);
                deferred_media.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
                play_btn.parentNode.classList.add('pre-hide');
                deferred_media.classList.remove('pre-hide');
                window.youtube_media = deferred_media.querySelector('.js-youtube');
                setTimeout(() => {
                    window.youtube_media.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                }, 500);
            });
        });
    }

    setupThumbnailClick() {
        const self = this;

        this.querySelectorAll('.irq-product-media-main button.pre-hide').forEach((btn) => {
            btn.classList.remove('pre-hide');
        });

        this.small_imgs.forEach((small_img) => {
            small_img.addEventListener('click', function (event) {
                event.preventDefault();
                self.sliderContainerMediasToPage(small_img.dataset.mediaIndex * 1);
                self.querySelectorAll('.product__media-item').forEach((large_img) => {
                    const deferred_media = large_img.querySelector('deferred-media');
                    if (deferred_media && !deferred_media.getAttribute('loaded')) {
                        large_img.querySelector('.product__modal-opener').classList.add('pre-hide');
                        deferred_media.classList.remove('pre-hide');
                        const content = document.createElement('div');
                        content.appendChild(deferred_media.querySelector('template').content.firstElementChild.cloneNode(true));
                        deferred_media.setAttribute('loaded', true);
                        deferred_media.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
                        let video = deferred_media.querySelector('.js-youtube');
                        video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                    } else {
                        const img = large_img.querySelector('img.lazyload');
                        if (img) {
                            img.setAttribute('src', img.getAttribute('data-src'));
                            img.classList.remove('lazyload');
                        }
                    }
                });

            });
        });
    }

    setupDesktopSnap() {
        const self = this;

        this.querySelectorAll('.slider-container-thumbnails button.pre-hide').forEach((btn) => {
            btn.classList.remove('pre-hide');
        });

        self.container_thumbnails_list_btn_next.addEventListener('click', function () {
            if (self.container_thumbnails_scroller.scrollLeft + self.container_thumbnails_scroller.clientWidth + 100 > self.container_thumbnails_scroller.scrollWidth) {
                self.container_thumbnails_scroller.scrollTo({left: 0, behavior: 'smooth'});
            } else {
                self.container_thumbnails_scroller.scrollBy({left: self.container_thumbnails_scroller.clientWidth, behavior: 'smooth'});
            }
        });

        self.container_thumbnails_list_btn_prev.addEventListener('click', function () {
            if (self.container_thumbnails_scroller.scrollLeft < 100) {
                self.container_thumbnails_scroller.scrollTo({left: self.container_thumbnails_scroller.scrollWidth, behavior: 'smooth'});
            } else {
                self.container_thumbnails_scroller.scrollBy({left: -self.container_thumbnails_scroller.clientWidth, behavior: 'smooth'});
            }
        });
    }
}

customElements.define('product-template', ProductTemplate);

class QuickShopDialog extends HTMLElement {
    constructor() {
        super();
        this.setupOnResize();
        this.querySelector('.close').addEventListener('click', this.onCloseClick.bind(this));
    }

    onResize() {
        let self_left = 40;
        let self_right = 40;
        if (window.innerWidth > 1280) {
            self_left = parseInt((window.innerWidth - 1200) / 2);
            self_right = window.innerWidth - self_left - 1200;
        }
        let self_width = window.innerWidth - self_left - self_right;
        this.style.left = self_left + 'px';
        this.style.right = self_right + 'px';
        this.style.width = self_width + 'px';
    }

    setupOnResize() {
        const self = this;
        function onQsResize() {
            self.onResize();
        }

        window.addEventListener('resize', debounce(() => { self.onResize(); }, 500));
    }

    onCloseClick() {
        this.hide();
    }

    hide() {
        document.body.classList.remove('disable-scroll');
        document.querySelector('#quick-shop-mask-full').classList.remove('show');
        window.quick_shop.classList.remove('show');
    }

    show() {
        document.body.classList.add('disable-scroll');
        document.querySelector('#quick-shop-mask-full').classList.add('show');
        this.onResize();
        window.quick_shop.classList.add('show');
    }

    initProduct(handle) {
        const self = this;
        window.qa_popup_product.innerHTML = '';
        let time_now = new Date().getTime();
        fetch('/products/' + handle + '?t=' + time_now, {
            method: "GET",
            credentials: "include"
        }).then(response => response.text()).then(html => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, 'text/html');
            doc.querySelector('product-template').classList.add('is-quick-shop');
            let p_html = doc.querySelector('product-template').outerHTML;
            window.qa_popup_product.innerHTML = p_html;
            window.lazyload(window.qa_popup_product.querySelectorAll('.lazyload'));
        });
    }
}

customElements.define('quick-shop-dialog', QuickShopDialog);

window.quick_shop = document.querySelector('quick-shop-dialog');
const qs_mask_full = document.querySelector('#quick-shop-mask-full');
qs_mask_full.addEventListener('click', (event) => {
    window.quick_shop.hide();
});
window.qa_popup_product = window.quick_shop.querySelector('.popup_product');

document.querySelectorAll('.quick_shop_btn').forEach((quick_shop_btn) => {
    quick_shop_btn.addEventListener('click', (event) => {
        event.preventDefault();
        window.quick_shop.initProduct(quick_shop_btn.dataset.handle);
        window.quick_shop.show();
    });
});